import React from "react";
import PaymentList from "../../components/event/PaymentList";

const PaymentsPage = () => {
    return <PaymentList/>
}

export default PaymentsPage;